// Svelte 5 no longer needs svelte/store imports for basic reactivity

// Create reactive state for the modal (private - not exported)
export const modalState = $state({ selected: null, context: null });

// Function to show a modal. context is optional modal-specific data, e.g. { tab: "integrations" } for Options.
export function showModal(modalName, context = null) {
    modalState.context = context;
    modalState.selected = modalName;
}

// Function to hide the modal
export function hideModal() {
    modalState.selected = null;
    modalState.context = null;
}